export const DISPLAY_LOADER = "DISPLAY_LOADER";
export const RESET_APP_STATE = "RESET_APP_STATE";
export const TOGGLE_MODAL = "TOGGLE_MODAL";
export const RESET_NOTES_TAB = "RESET_NOTES_TAB";
export const RESET_EMAIL_TAB = "RESET_EMAIL_TAB";
export const RESET_HISTROY_TAB = "RESET_HISTROY_TAB";
export const GET_SCHEDULE_VISITS_CARD_FALIURE =
  "GET_SCHEDULE_VISITS_CARD_FALIURE";
export const GET_SCHEDULE_VISITS_CARD = "GET_SCHEDULE_VISITS_CARD";
export const GET_SCHEDULE_VISITS_CARD_LOADING = 'GET_SCHEDULE_VISITS_CARD_LOADING';
export const GET_SCHEDULE_VISITS_CARD_CLEAR_API_STATUS = 'GET_SCHEDULE_VISITS_CARD_CLEAR_API_STATUS';
export const GET_PATIENT_INFO_FALIURE = "GET_PATIENT_INFO_FALIURE";
export const GET_PATIENT_INFO_LOADING = 'GET_PATIENT_INFO_LOADING';
export const GET_PATIENT_INFO = "GET_PATIENT_INFO";
export const GET_HEADER_INFO_FALIURE = "GET_HEADER_INFO_FALIURE";
export const GET_HEADER_INFO = "GET_HEADER_INFO";
export const GET_NOTES_FALIURE = "GET_NOTES_FALIURE";
export const GET_HEADER_INFO_LOADING = 'GET_HEADER_INFO_LOADING';
export const GET_NOTES = "GET_NOTES";
export const RESET_PATIENT_INFO = "RESET_PATIENT_INFO";
export const GET_PRODUCT_INFO_FALIURE = "GET_PRODUCT_INFO_FALIURE";
export const GET_PRODUCT_INFO_LOADING = 'GET_PRODUCT_INFO_LOADING';
export const GET_PRODUCT_INFO = "GET_PRODUCT_INFO";
export const SET_PRODUCT_INFO = "SET_PRODUCT_INFO";
export const RESET_PRODUCT_INFO = 'RESET_PRODUCT_INFO';
export const GET_PRODUCT_LIST = "GET_PRODUCT_LIST";
export const GET_PRODUCT_LIST_FALIURE = "GET_PRODUCT_LIST_FALIURE";
export const GET_QTY_BY_PRODUCT_ID_LOADING = 'GET_QTY_BY_PRODUCT_ID_LOADING';
export const GET_QTY_BY_PRODUCT_ID_FALIURE = "GET_QTY_BY_PRODUCT_ID_FALIURE";
export const GET_QTY_BY_PRODUCT_ID = "GET_QTY_BY_PRODUCT_ID";
export const SAVE_PRODUCT_CHANGES_FALIURE = "SAVE_PRODUCT_CHANGES_FALIURE";
export const SAVE_PRODUCT_CHANGES = "SAVE_PRODUCT_CHANGES";
export const SAVE_PRODUCT_CHANGES_LOADING = 'SAVE_PRODUCT_CHANGES_LOADING';
export const TOGGLE_PRODUCT_CHANGE_MODAL = "TOGGLE_PRODUCT_CHANGE_MODAL";
export const GET_CONSULT_QUESTION_FALIURE = "GET_CONSULT_QUESTION_FALIURE";
export const GET_CONSULT_QUESTION = "GET_CONSULT_QUESTION";
export const GET_CONSULT_QUESTION_LOADING = 'GET_CONSULT_QUESTION_LOADING';
export const GET_PENDING_FILES_CARD_FALIURE = "GET_PENDING_FILES_CARD_FALIURE";
export const GET_PENDING_FILES_CARD = "GET_PENDING_FILES_CARD";
export const GET_PENDING_FILES_CARD_LOADING = 'GET_PENDING_FILES_CARD_LOADING';
export const GET_PENDING_FILES_CARD_CLEAR_API_STATUS = 'GET_PENDING_FILES_CARD_CLEAR_API_STATUS';
export const GET_ORDER_NOTES_FAILURE = "GET_ORDER_NOTES_FAILURE";
export const GET_ORDER_NOTES = "GET_ORDER_NOTES";
export const GET_ORDER_NOTES_LOADING = "GET_ORDER_NOTES_LOADING";
export const GET_PATIENT_NOTES_FAILURE = "GET_PATIENT_NOTES_FAILURE";
export const GET_PATIENT_NOTES = "GET_PATIENT_NOTES";
export const GET_PATIENT_NOTES_LOADING = "GET_PATIENT_NOTES_LOADING";
export const GET_MEDICAL_ORDER_NOTES = "GET_MEDICAL_ORDER_NOTES";
export const GET_MEDICAL_ORDER_NOTES_LOADING = "GET_MEDICAL_ORDER_NOTES_LOADING";
export const GET_MEDICAL_ORDER_NOTES_FAILURE = "GET_MEDICAL_ORDER_NOTES_FAILURE";
export const GET_MEDICAL_PATIENT_NOTES = "GET_MEDICAL_PATIENT_NOTES";
export const GET_MEDICAL_PATIENT_NOTES_LOADING = "GET_MEDICAL_PATIENT_NOTES_LOADING";
export const GET_MEDICAL_PATIENT_NOTES_FAILURE = "GET_MEDICAL_PATIENT_NOTES_FAILURE";
export const GET_SOAP_NOTE_INFO = "GET_SOAP_NOTE_INFO";
export const SET_SELECTED_TAB = "SET_SELECTED_TAB";
export const GET_EMAIL_FALIURE = "GET_EMAIL_FALIURE";
export const GET_EMAIL = "GET_EMAIL";
export const GET_EMAIL_LOADING = 'GET_EMAIL_LOADING';
export const GET_HISTORY_FALIURE = "GET_HISTORY_FALIURE";
export const GET_HISTORY = "GET_HISTORY";
export const GET_HISTORY_LOADING = 'GET_HISTORY_LOADING';
export const GET_EMAIL_TEMPLATE_FALIURE = "GET_EMAIL_TEMPLATE_FALIURE";
export const GET_EMAIL_TEMPLATE = "GET_EMAIL_TEMPLATE";
export const SET_DENIAL_AND_SEND_EMAIL = "SET_DENIAL_AND_SEND_EMAIL";
export const GET_DENIAL_REASON_FAILURE = "GET_DENIAL_REASON_FAILURE";
export const GET_DENIAL_REASON = "GET_DENIAL_REASON";
export const GET_SUB_AND_EMAIL_FALIURE = "GET_SUB_AND_EMAIL_FALIURE";
export const GET_SUB_AND_EMAIL = "GET_SUB_AND_EMAIL";
export const DENIAL_AND_EMAIL_FALIURE = "DENIAL_AND_EMAIL_FALIURE";
export const DENIAL_AND_EMAIL = "DENIAL_AND_EMAIL";
export const RESET_EMAIL_AND_DENY_DATA = "RESET_EMAIL_AND_DENY_DATA";
export const RESET_APPROVE_AND_MAIL_DATA = "RESET_APPROVE_AND_MAIL_DATA";
export const GET_APPROVE_AND_EMAIL_PRESCRIER_INFO_FAILURE =
  "GET_APPROVE_AND_EMAIL_PRESCRIER_INFO_FAILURE";
export const GET_APPROVE_AND_EMAIL_PRESCRIER_INFO =
  "GET_APPROVE_AND_EMAIL_PRESCRIER_INFO";
export const GET_APPROVE_AND_EMAIL_PRESCRIER_INFO_LOADING = 'GET_APPROVE_AND_EMAIL_PRESCRIER_INFO_LOADING';
export const RESET_APPROVE_AND_EMAIL_PRESCRIER_INFO = 'RESET_APPROVE_AND_EMAIL_PRESCRIER_INFO';
export const SET_APPROVE_AND_MAIL_DATA = "SET_APPROVE_AND_MAIL_DATA";
export const SET_APPROVE_AND_MAIL_MAIN_DATA = "SET_APPROVE_AND_MAIL_MAIN_DATA";
export const HANDLE_GLOBAL_VALUE_CHANGE = "HANDLE_GLOBAL_VALUE_CHANGE";
export const GET_ORDER_AND_PRESCRIBER_FLAGS_FAILURE =
  "GET_ORDER_AND_PRESCRIBER_FLAGS_FAILURE";
export const GET_ORDER_AND_PRESCRIBER_FLAGS = "GET_ORDER_AND_PRESCRIBER_FLAGS";
export const GET_ORDER_AND_PRESCRIBER_FLAGS_LOADING = 'GET_ORDER_AND_PRESCRIBER_FLAGS_LOADING';
export const RESET_ORDER_AND_PRESCRIBER_FLAGS = 'RESET_ORDER_AND_PRESCRIBER_FLAGS';
export const VERIFY_PIN_FALIURE = "VERIFY_PIN_FALIURE";
export const VERIFY_PIN = "VERIFY_PIN";
export const TOGGLE_ERROR_MODAL = "TOGGLE_ERROR_MODAL";
export const SET_MODAL_ALERT_OPEN = "SET_MODAL_ALERT_OPEN";
export const APPROVE_AND_MAIL_SUBMIT_FALIURE =
  "APPROVE_AND_MAIL_SUBMIT_FALIURE";
export const APPROVE_AND_MAIL_SUBMIT = "APPROVE_AND_MAIL_SUBMIT";
export const SET_START_VISIT = "SET_START_VISIT";
export const SET_START_VISIT_FALIURE = "SET_START_VISIT_FALIURE";
export const ADD_NOTE_FAILURE = "ADD_NOTE_FAILURE";
export const ADD_NOTE = "ADD_NOTE";
export const ADD_SOAP_NOTE = "ADD_SOAP_NOTE";
export const RESET_ADD_NOTE_DATA = "RESET_ADD_NOTE_DATA";
export const SET_ADD_NOTE = "SET_ADD_NOTE";
export const SET_ADD_SOAP_NOTE = "SET_ADD_SOAP_NOTE";
export const GET_ADD_NOTE = "GET_ADD_NOTE";
export const RESET_ADD_NOTE = "RESET_ADD_NOTE";
export const GET_TEXT_PATIENT_TEMPLATE_FALIURE =
  "GET_TEXT_PATIENT_TEMPLATE_FALIURE";
export const GET_TEXT_PATIENT_TEMPLATE = "GET_TEXT_PATIENT_TEMPLATE";
export const TEXT_PATIENT_FALIURE = "TEXT_PATIENT_FALIURE";
export const TEXT_PATIENT = "TEXT_PATIENT";
export const TEXT_PATIENT_LOADING = 'TEXT_PATIENT_LOADING';
export const RESET_TEXT_PATIENT = "RESET_TEXT_PATIENT";
export const POST_CALL_DETAILS_FALIURE = "POST_CALL_DETAILS_FALIURE";
export const POST_CALL_DETAILS = "POST_CALL_DETAILS";
export const CALL_END = "CALL_END";
export const CALL_END_FAILURE = "CALL_END_FAILURE";
export const GET_DOSESPOT_DATA_FALIURE = "GET_DOSESPOT_DATA_FALIURE";
export const GET_DOSESPOT_DATA = "GET_DOSESPOT_DATA";
export const RESET_DOSESPOT_DATA = 'RESET_DOSESPOT_DATA';
export const LOG_ERROR_FALIURE = "LOG_ERROR_FALIURE";
export const LOG_ERROR = "LOG_ERROR";
export const CHECK_DOSESPOT_FALIURE = "CHECK_DOSESPOT_FALIURE";
export const CHECK_DOSESPOT = "CHECK_DOSESPOT";
export const LOG_OFF_FALIURE = "LOG_OFF_FALIURE";
export const LOG_OFF = "LOG_OFF";

// send order to cs
export const GET_REASONS_FALIURE = "GET_REASONS_FALIURE";
export const GET_REASONS = "GET_REASONS";
export const SEND_ORDER_TO_CS_FALIURE = "SEND_ORDER_TO_CS_FALIURE";
export const SEND_ORDER_TO_CS = "SEND_ORDER_TO_CS";
export const RESET_SEND_ORDER_TO_CS_DATA = "RESET_SEND_ORDER_TO_CS_DATA";
export const SET_SEND_ORDER_TO_CS_DATA = "SET_SEND_ORDER_TO_CS_DATA";

// call patient
export const GET_CALL_PATIENT_DETAILS_FAILURE =
  "GET_CALL_PATIENT_DETAILS_FAILURE";
export const GET_CALL_PATIENT_DETAILS = "GET_CALL_PATIENT_DETAILS";
export const SET_CALL_PATIENT_DETAILS = "SET_CALL_PATIENT_DETAILS";
export const RESET_CALL_PATIENT_DETAILS = "RESET_CALL_PATIENT_DETAILS";
export const CALL_PATIENT_LOADING = 'CALL_PATIENT_LOADING';
export const CALL_PATIENT = "CALL_PATIENT";
export const CALL_PATIENT_FAILURE = "CALL_PATIENT_FAILURE";
export const SET_MODAL_TWILIO_ALERT_OPEN = "SET_MODAL_TWILIO_ALERT_OPEN";

// Email Patient
export const RESET_EMAIL_PATIENT_DATA = "RESET_EMAIL_PATIENT_DATA";
export const EMAIL_PATIENT_DATA = "EMAIL_PATIENT_DATA";
export const EMAIL_PATIENT_DATA_FAILURE = "EMAIL_PATIENT_DATA_FAILURE";
export const EMAIL_PATIENT_DATA_LOADING = 'EMAIL_PATIENT_DATA_LOADING';

// temp consts
export const VALIDATE_USER_CREDENTIAL = "VALIDATE_USER_CREDENTIAL";
export const VALIDATION_FAILURE = "VALIDATION_FAILURE";
export const VALIDATE_TOKEN = 'VALIDATE_TOKEN';
export const VALIDATE_TOKEN_FAILURE = 'VALIDATE_TOKEN_FAILURE';

// UPLOAD VIEW
export const UPLOAD_DOC_PATIENT_FAILURE = "UPLOAD_DOC_PATIENT_FAILURE";
export const UPLOAD_DOC_PATIENT = "UPLOAD_DOC_PATIENT";
export const SET_UPLOAD_DOCS = "SET_UPLOAD_DOCS";

// PDF VIEW
export const PDF_DOC_FAILURE = "PDF_DOC_FAILURE";
export const PDF_DOC = "PDF_DOC";
export const SET_UPLOAD_PDFS = "SET_UPLOAD_PDFS";
export const PDF_AV_LOADING = "PDF_AV_LOADING";
export const PDF_AV = "PDF_AV";
export const PDF_NAV = "PDF_NAV";

// SEARCH
export const SET_SEARCH_ERROR = "SET_SEARCH_ERROR";
export const SET_SEARCH_DATA_FAILURE = "SET_SEARCH_DATA_FAILURE";
export const SET_SEARCH_DATA = "SET_SEARCH_DATA";
export const CLEAR_SEARCH_DATA = "CLEAR_SEARCH_DATA";
export const SET_SEARCH_LOADING = 'SET_SEARCH_LOADING';

// call summary reasons
export const SET_CALL_SUMMARY = 'SET_CALL_SUMMARY';
export const CALL_SUMMARY_REASONS = 'CALL_SUMMARY_REASONS';
export const CALL_SUMMARY_REASONS_FAILURE = 'CALL_SUMMARY_REASONS_FAILURE';
export const INSERT_CALL_SUMMARY = 'INSERT_CALL_SUMMARY';
export const INSERT_CALL_SUMMARY_FAILURE = 'INSERT_CALL_SUMMARY_FAILURE';

// filter by
export const SET_FILTER_BY = 'SET_FILTER_BY';

// patient medical necessity pdf data
export const GET_PDF_DATA = 'GET_PDF_DATA';
export const GET_PDF_DATA_FALIURE = 'GET_PDF_DATA_FALIURE';
export const SET_CMN_TEMPLATE_FORM_FIELD = 'SET_CMN_TEMPLATE_FORM_FIELD';

export const SET_SOAP_NOTE_TEMPLATE = 'SET_SOAP_NOTE_TEMPLATE';
export const GET_SOAP_NOTE_TEMPLATES = 'GET_SOAP_NOTE_TEMPLATES';
export const GET_SOAP_NOTE_TEMPLATES_FAILURE = 'GET_SOAP_NOTE_TEMPLATES_FAILURE';
export const GET_SOAP_NOTE_TEMPLATES_LOADING = 'GET_SOAP_NOTE_TEMPLATES_LOADING';

export const GET_PATIENT_UPLOADS = 'GET_PATIENT_UPLOADS';
export const GET_PATIENT_UPLOADS_LOADING = 'GET_PATIENT_UPLOADS_LOADING';
export const GET_PATIENT_UPLOADS_FAILURE = 'GET_PATIENT_UPLOADS_FAILURE';

export const ADD_DOSESPOT_PATIENT_PRESCRIPTION = 'ADD_DOSESPOT_PATIENT_PRESCRIPTION';
export const ADD_DOSESPOT_PATIENT_PRESCRIPTION_LOADING = 'ADD_DOSESPOT_PATIENT_PRESCRIPTION_LOADING';
export const ADD_DOSESPOT_PATIENT_PRESCRIPTION_FAILURE = 'ADD_DOSESPOT_PATIENT_PRESCRIPTION_FAILURE';

export const GET_CHANGE_PRODUCT_LIST = 'GET_CHANGE_PRODUCT_LIST';
export const GET_CHANGE_PRODUCT_LIST_LOADING = 'GET_CHANGE_PRODUCT_LIST_LOADING';
export const GET_CHANGE_PRODUCT_LIST_FAILURE = 'GET_CHANGE_PRODUCT_LIST_FAILURE';
export const RESET_CHANGE_PRODUCT_LIST = 'RESET_CHANGE_PRODUCT_LIST';
export const CHANGE_PRODUCT_LIST_RESPONSE = 'CHANGE_PRODUCT_LIST_RESPONSE';
export const CHANGE_PRODUCT_LIST_ERROR = 'CHANGE_PRODUCT_LIST_ERROR';

export const GET_ALL_SUB_AND_EMAIL = 'GET_ALL_SUB_AND_EMAIL';
export const GET_ALL_SUB_AND_EMAIL_LOADING = 'GET_ALL_SUB_AND_EMAIL_LOADING';
export const GET_ALL_SUB_AND_EMAIL_FAILURE = 'GET_ALL_SUB_AND_EMAIL_FAILURE';
export const ALL_SUB_AND_EMAIL_RESPONSE = 'ALL_SUB_AND_EMAIL_RESPONSE';
export const ALL_SUB_AND_EMAIL_ERROR = 'ALL_SUB_AND_EMAIL_ERROR';

export const GET_PRODUCT_INFO_V3_LOADING = 'GET_PRODUCT_INFO_V3_LOADING';
export const GET_PRODUCT_INFO_V3 = 'GET_PRODUCT_INFO_V3';
export const GET_PRODUCT_INFO_V3_FAILURE = 'GET_PRODUCT_INFO_V3_FAILURE';
export const CLEAR_PRODUCT_INFO_V3 = 'CLEAR_PRODUCT_INFO_V3';

export const GET_EMAIL_REASONS_LOADING = 'GET_EMAIL_REASONS_LOADING';
export const GET_EMAIL_REASONS = 'GET_EMAIL_REASONS';
export const GET_EMAIL_REASONS_FAILURE = 'GET_EMAIL_REASONS_FAILURE';

export const GET_PRODUCT_COST_LOADING = 'GET_PRODUCT_COST_LOADING';
export const GET_PRODUCT_COST = 'GET_PRODUCT_COST';
export const GET_PRODUCT_COST_FAILURE = 'GET_PRODUCT_COST_FAILURE';
export const RESET_PRODUCT_COST = 'RESET_PRODUCT_COST';

export const ADD_PRODUCT_LOADING = 'ADD_PRODUCT_LOADING';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const ADD_PRODUCT_FAILURE = 'ADD_PRODUCT_FAILURE';

export const GET_EMAIL_TEMPLATE_V2 = 'GET_EMAIL_TEMPLATE_V2';
export const GET_EMAIL_TEMPLATE_V2_LOADING = 'GET_EMAIL_TEMPLATE_V2_LOADING';
export const GET_EMAIL_TEMPLATE_V2_FAILURE = 'GET_EMAIL_TEMPLATE_V2_FAILURE';
export const GET_SUB_AND_EMAIL_V2 = 'GET_SUB_AND_EMAIL_V2';
export const RESET_SUB_AND_EMAIL_V2 = 'RESET_SUB_AND_EMAIL_V2';

export const GET_APPROVE_EMAIL_TEMPLATE_V2 = 'GET_APPROVE_EMAIL_TEMPLATE_V2';
export const GET_APPROVE_EMAIL_TEMPLATE_V2_LOADING = 'GET_APPROVE_EMAIL_TEMPLATE_V2_LOADING';
export const GET_APPROVE_EMAIL_TEMPLATE_V2_FAILURE = 'GET_APPROVE_EMAIL_TEMPLATE_V2_FAILURE';
export const GET_APPROVE_SUB_AND_EMAIL_V2 = 'GET_APPROVE_SUB_AND_EMAIL_V2';
export const RESET_APPROVE_SUB_AND_EMAIL_V2 = 'RESET_APPROVE_SUB_AND_EMAIL_V2';

export const GET_DENY_EMAIL_TEMPLATE_V2 = 'GET_DENY_EMAIL_TEMPLATE_V2';
export const GET_DENY_EMAIL_TEMPLATE_V2_LOADING = 'GET_DENY_EMAIL_TEMPLATE_V2_LOADING';
export const GET_DENY_EMAIL_TEMPLATE_V2_FAILURE = 'GET_DENY_EMAIL_TEMPLATE_V2_FAILURE';
export const GET_DENY_SUB_AND_EMAIL_V2 = 'GET_DENY_SUB_AND_EMAIL_V2';
export const RESET_DENY_SUB_AND_EMAIL_V2 = 'RESET_DENY_SUB_AND_EMAIL_V2';

export const GET_SAVED_FLAGS = 'GET_SAVED_FLAGS';
export const GET_SAVED_FLAGS_LOADING = 'GET_SAVED_FLAGS_LOADING';
export const GET_SAVED_FLAGS_FAILURE = 'GET_SAVED_FLAGS_FAILURE';
export const RESET_SAVED_FLAGS = 'RESET_SAVED_FLAGS';

export const SAVE_FLAGS = 'SAVE_FLAGS';
export const SAVE_FLAGS_LOADING = 'SAVE_FLAGS_LOADING';
export const SAVE_FLAGS_FAILURE = 'SAVE_FLAGS_FAILURE';

export const SAVE_EXTENDED_CONSULT_LOADING = 'SAVE_EXTENDED_CONSULT_LOADING';
export const SAVE_EXTENDED_CONSULT = 'SAVE_EXTENDED_CONSULT';
export const SAVE_EXTENDED_CONSULT_FAILURE = 'SAVE_EXTENDED_CONSULT_FAILURE';

export const REMOVE_ORDERS_FROM_LV = 'REMOVE_ORDERS_FROM_LV';

export const SEND_PASSWORD_RECOVERY_OTP = 'SEND_PASSWORD_RECOVERY_OTP';
export const SENT_PASSWORD_RECOVERY_OTP = 'SENT_PASSWORD_RECOVERY_OTP';
export const FAILD_TO_SEND_PASSWORD_RECOVERY_OTP = 'FAILD_TO_SEND_PASSWORD_RECOVERY_OTP';

export const VALIDATE_PASSWORD_RECOVERY_OTP = 'VALIDATE_PASSWORD_RECOVERY_OTP';
export const VALIDATED_PASSWORD_RECOVERY_OTP = 'VALIDATED_PASSWORD_RECOVERY_OTP';
export const FAILED_TO_VALIDATE_PASSWORD_RECOVERY_OTP = 'FAILED_TO_VALIDATE_PASSWORD_RECOVERY_OTP';

export const RESET_PASSWORD_USING_PASSWORD_RECOVERY_OTP = 'RESET_PASSWORD_USING_PASSWORD_RECOVERY_OTP';
export const FAILED_TO_RESET_PASSWORD_USING_PASSWORD_RECOVERY_OTP = 'FAILED_TO_RESET_PASSWORD_USING_PASSWORD_RECOVERY_OTP';
export const PASSWORD_IS_RESET_USING_PASSWORD_RECOVERY_OTP = 'PASSWORD_IS_RESET_USING_PASSWORD_RECOVERY_OTP';

export const CLEAR_RECOVER_PASSWORD = 'CLEAR_RECOVER_PASSWORD';

export const GET_TASKS = 'GET_TASKS';
export const GET_TASKS_LOADING = 'GET_TASKS_LOADING';
export const GET_TASKS_FAILURE = 'GET_TASKS_FAILURE';

export const GET_TASK_BY_ORDER_ID = 'GET_TASK_BY_ORDER_ID';
export const GET_TASK_BY_ORDER_ID_LOADING = 'GET_TASK_BY_ORDER_ID_LOADING';
export const GET_TASK_BY_ORDER_ID_FAILURE = 'GET_TASK_BY_ORDER_ID_FAILURE';

export const UPDATE_TASK = 'UPDATE_TASK';
export const UPDATE_TASK_LOADING = 'UPDATE_TASK_LOADING';
export const UPDATE_TASK_FAILURE = 'UPDATE_TASK_FAILURE';

export const GET_ICD10CODES_BY_ORDER_ID_LOADING = 'GET_ICD10CODES_BY_ORDER_ID_LOADING';
export const GET_ICD10CODES_BY_ORDER_ID = 'GET_ICD10CODES_BY_ORDER_ID';
export const GET_ICD10CODES_BY_ORDER_ID_FAILURE = 'GET_ICD10CODES_BY_ORDER_ID_FAILURE';
export const REMOVE_ICD10CODE_FROM_COLLECTION = 'REMOVE_ICD10CODE_FROM_COLLECTION';

export const GET_ICD10CODES_BY_PATIENT_ID_LOADING = 'GET_ICD10CODES_BY_PATIENT_ID_LOADING';
export const GET_ICD10CODES_BY_PATIENT_ID = 'GET_ICD10CODES_BY_PATIENT_ID';
export const GET_ICD10CODES_BY_PATIENT_ID_FAILURE = 'GET_ICD10CODES_BY_PATIENT_ID_FAILURE';

export const ADD_ICD10CODES_LOADING = 'ADD_ICD10CODES_LOADING';
export const ADD_ICD10CODES = 'ADD_ICD10CODES';
export const ADD_ICD10CODES_FAILURE = 'ADD_ICD10CODES_FAILURE';

export const REMOVE_ICD10CODES_LOADING = 'REMOVE_ICD10CODES_LOADING';
export const REMOVE_ICD10CODES = 'REMOVE_ICD10CODES';
export const REMOVE_ICD10CODES_FAILURE = 'REMOVE_ICD10CODES_FAILURE';

export const GET_ICD10CODES_BY_TERMS_LOADING = 'GET_ICD10CODES_BY_TERMS_LOADING';
export const GET_ICD10CODES_BY_TERMS = 'GET_ICD10CODES_BY_TERMS';
export const GET_ICD10CODES_BY_TERMS_FAILURE = 'GET_ICD10CODES_BY_TERMS_FAILURE';
export const CLEAR_ICD10CODES_BY_TERMS = 'CLEAR_ICD10CODES_BY_TERMS';

export const CHANGE_PASSWORD_IN_PROGRESS = 'CHANGE_PASSWORD_IN_PROGRESS';
export const PASSWORD_IS_CHANGED = 'PASSWORD_IS_CHANGED';
export const FAILED_TO_CHANGE_PASSWORD = 'FAILED_TO_CHANGE_PASSWORD';
